import script from "./EventSourceForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventSourceForm.vue?vue&type=script&lang=ts&setup=true"

import "./EventSourceForm.vue?vue&type=style&index=0&id=3c8aba4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c8aba4e"]])

export default __exports__